const paths = require('../paths.json');

const PLATFORM_HOSTNAMES = ['fitwith.io', 'withme.so', 'with-me.site', 'with-me.shop', 'with-me.store', 'localhost'];

/**
 * True when the page is served from one of the platform hostnames, false on a
 * creator's custom domain (and when there is no window).
 */
export function isPlatformHost() {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname.replace(/^www\./, '');
    return PLATFORM_HOSTNAMES.includes(hostname);
}

/**
 * Returns the correct backend API URL.
 * On custom domains (e.g. mylast.love), returns https://api.mylast.love/
 * On platform domains (e.g. withme.so), returns the default paths.BACKEND_URL.
 */
export function getBackendUrl() {
    if (typeof window === 'undefined' || isPlatformHost()) return paths.BACKEND_URL;
    const hostname = window.location.hostname.replace(/^www\./, '');
    return `https://api.${hostname}/`;
}

export default getBackendUrl;
